import React, { useRef, useEffect } from "react";
import * as XLSX from "xlsx";

// Función para convertir fechas de Excel
const formatExcelDate = (date) => {
  const validateDateFormat = (inputDate) => /^\d{4}-\d{2}-\d{2}$/.test(inputDate);
  const convertToDateFormat = (inputDate) => {
    if (!isNaN(inputDate)) {
      const excelEpoch = new Date(1899, 11, 30);
      const parsedDate = new Date(excelEpoch.getTime() + inputDate * 86400000);
      return `${parsedDate.getFullYear()}-${String(parsedDate.getMonth() + 1).padStart(2, "0")}-${String(parsedDate.getDate()).padStart(2, "0")}`;
    }
    const parsedDate = new Date(inputDate);
    return !isNaN(parsedDate.getTime()) ? `${parsedDate.getFullYear()}-${String(parsedDate.getMonth() + 1).padStart(2, "0")}-${String(parsedDate.getDate()).padStart(2, "0")}` : null;
  };

  if (validateDateFormat(date)) return date;
  const converted = convertToDateFormat(date);
  return converted || "Invalid date";
};

// Función para convertir horas de Excel
const formatExcelTime = (excelTime) => {
  const totalMinutes = Math.floor(excelTime * 24 * 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

// Validación detallada de campos requeridos
const validateRequiredFields = (data) => {
  const requiredFields = ["Grupo", "Rut", "Nombre", "Telefono", "Origen", "FechaProgramado", "HoraProgramado", "Destino"];
  const invalidRows = [];

  data.forEach((row, index) => {
    const missingFields = requiredFields.filter((field) => !row[field] || row[field].toString().trim() === "");
    if (missingFields.length > 0) {
      invalidRows.push({
        rowNumber: index + 2, // Fila en Excel (1 base + encabezado)
        missingFields,
      });
    }
  });

  return invalidRows;
};

const FileUploader = ({ onFileRead, onInvalidFile, setResetFileInput }) => {
  const inputRef = useRef();

  useEffect(() => {
    if (setResetFileInput) {
      setResetFileInput(() => () => {
        if (inputRef.current) {
          inputRef.current.value = null;
        }
      });
    }
  }, [setResetFileInput]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const processedData = jsonData.map((row) => ({
        ...row,
        FechaProgramado: row.FechaProgramado ? formatExcelDate(row.FechaProgramado) : "",
        HoraProgramado: row.HoraProgramado ? formatExcelTime(row.HoraProgramado) : "",
      }));

      const invalidRows = validateRequiredFields(processedData);

      if (invalidRows.length === 0) {
        onFileRead(processedData);
      } else {
        const errorDetails = invalidRows.map((row) => `Fila ${row.rowNumber}: faltan campos [${row.missingFields.join(", ")}]`).join("\n");
        onInvalidFile(errorDetails);
      }
    };

    reader.readAsBinaryString(file);
  };

  return <input ref={inputRef} type="file" className="form-control w-100" accept=".xlsx, .xls" onChange={handleFileChange} />;
};

export default FileUploader;
